import { marked } from 'marked';

import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'markdownToHtml',
  pure: true,
  standalone: false,
})
export class MarkdownToHtml implements PipeTransform {
  transform(value: string, bigText: boolean = false): string {
    if (!value) {
      return '';
    }
    return this.parseMarkdownToHtml(value, bigText);
  }

  parseMarkdownToHtml(markdown: string, bigText?: boolean): string {
    const parsed = marked.parse(markdown, { breaks: true }) as string;
    return parsed
      .replace(/<p/g, `<p class="zef-text-p${!bigText ? 2 : 1}"`)
      .replace(/<h3/g, `<h3 class="zef-text-h${!bigText ? 4 : 3}"`)
      .replace(/<h2/g, `<h2 class="zef-text-h${!bigText ? 3 : 2}"`)
      .replace(/<h1/g, `<h1 class="zef-text-h${!bigText ? 2 : 1}"`)
      .replace(/<li/g, `<li class="zef-text-p${!bigText ? 2 : 1}"`)
      .replace(/<table/g, `<table class="zef-text-p${!bigText ? 2 : 1}"`)
      .trim();
  }
}
